import "scroll-behavior-polyfill";

const scrollToTop = (): void => {
  const target = document.getElementById('EventXRegForm');
  target?.scrollTo({ top: 0, behavior: 'smooth' });
};

export default scrollToTop;
